import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../contexts/AuthContext";
import logo from "../assets/logo.svg";
import "./Login.css";

/**
 * Full-screen login page with Google OAuth sign-in.
 */
function Login() {
  const { login } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src={logo} alt="Insuraviews" className="login-logo-img" />
        </div>
        <h1 className="login-title">Insuraviews</h1>
        <div className="login-button-wrapper">
          <GoogleLogin
            onSuccess={login}
            onError={() => console.error("Google login failed")}
            hosted_domain="insuraviews.com"
            size="large"
            width="320"
            text="signin_with"
            shape="rectangular"
            theme="outline"
          />
        </div>
      </div>
    </div>
  );
}

export default Login;
